import get from 'lodash.get';

const getCleanUrlsEnabled = (rootState) =>
  get(rootState, 'ws.site.meta.onlinestore.cleanUrlsEnabled', false);

export default getCleanUrlsEnabled;
